import moment from "moment";
import { useEffect, useReducer, useRef, useState, Fragment } from "react";
import { CHART_HEADER_CONST, CHART_OPTIONS, DRUG_ADMINISTRATION_TYPE, getDrugAdministrationHeader, PRESCRIPTION_OPTIONS } from "../../../common/constant/common-constants";
import "./DrugAdministration.scss";
import TimePicker from "react-time-picker/dist/TimePicker";
import { connect } from 'react-redux';

function DrugAdminstration(props) {
    const [drugModal, setDrugModal] = useState(false);
    const timeFormat = "HH:mm";
    const [drugTime, setDrugTime] = useState("");
    const [timeErr, setTimeErr] = useState("");

    useEffect(() => {
        setTimeErr("")
    }, [drugTime])

    // const handleChange = (prescriptionId, prescriptionType, administrationId, time, event) => {
    //     // let value = event.target.checked;

    //     let tempData = props.data;
    //     // console.log("props,", props);

    //     let prescription = tempData.filter((pres) => (pres.id === prescriptionId) && (pres.type === prescriptionType))[0];
    //     console.log("prescription", prescription);

    //     if (prescription) {
    //         let drugAdministrations = prescription.drugAdministrations;
    //         let administration = drugAdministrations.filter((adm) => adm.id === administrationId)[0];

    //         if (!administration) {
    //             administration = {
    //                 time: time,
    //                 id: administrationId,
    //             }
    //             drugAdministrations.push(administration);
    //         } else {
    //             let isNew = (administration.id.indexOf("new-") > -1);

    //             if (isNew) {
    //                 // if (!value) {
    //                 drugAdministrations
    //                     .splice(
    //                         drugAdministrations.findIndex(e => e.id === administration.id),
    //                         1
    //                     );
    //                 // }
    //             }
    //         }

    //         prescription.drugAdministrations = drugAdministrations;

    //         props.handleChangeData(tempData);
    //     }
    // }
    const handleTimeModal = (event) => {
        if (event.target.checked) {
            setDrugModal(event.target.id);
        }
        else setDrugModal("")
    }
    const handleModalCancel = () => {
        setTimeErr("")
        setDrugModal("");
    }
    const handleModalConfirm = (prescriptionId, prescriptionType, administrationId, headerTime) => {
        if (drugTime) {
            let hTime = parseInt(headerTime.slice(0, 2));
            let dTime = parseInt(drugTime.slice(0, 2));
            console.log("hTime", hTime)
            console.log("dTime", dTime)

            if (dTime !== hTime) { // not entered valid time
                setTimeErr(`Enter valid time between ${hTime} :00 ${hTime >= 12 ? "pm" : "am"} and ${hTime + 1} :00 ${(hTime === 11) || (hTime >= 12 && hTime + 1 != 24) ? "pm" : "am"}`);
            } else {
                setDrugModal("");
                setTimeErr("");
                let tempData = props.data;

                let prescription = tempData.filter((pres) => (pres.id === prescriptionId) && (pres.type === prescriptionType))[0];

                if (prescription) {
                    let drugAdministrations = prescription.drugAdministrations;
                    let administration = drugAdministrations.filter((adm) => adm.id === administrationId)[0];

                    if (!administration) {
                        administration = {
                            time: headerTime,
                            id: administrationId,
                            exactTime: drugTime
                        }
                        drugAdministrations.push(administration);
                    } else {
                        let isNew = (administration.id.indexOf("new-") > -1);

                        if (isNew) {
                            drugAdministrations
                                .splice(
                                    drugAdministrations.findIndex(e => e.id === administration.id),
                                    1
                                );
                        }
                    }

                    prescription.drugAdministrations = drugAdministrations;

                    props.handleChangeData(tempData);
                }
                setDrugTime("")
            }
        } else {
            console.log("enter time");
        }
    }

    const getTablewiseHtml = (prescriptionTable, headerModified) => {
        let html = prescriptionTable.map((prescription, row) => {
            return (
                <tr key={row}>
                    {
                        headerModified.map((header, col) => {

                            if (header === CHART_HEADER_CONST.PARAMETERS) {
                                return (
                                    <td className="drug-data-cell sticky" >
                                        <div className="drug-detail">
                                            <div className="drug-name">
                                                {prescription.name}
                                            </div>
                                            <div className="drug-data">
                                                {prescription.dosage && <div className="dosage drug-box">
                                                    {
                                                        `${prescription.dosage} mg`
                                                    }
                                                </div>}
                                                {prescription.frequency && <div className="frequency drug-box">
                                                    {
                                                        prescription.frequency
                                                    }
                                                </div>}
                                                {prescription.route && <div className="route drug-box">
                                                    {
                                                        prescription.route
                                                    }
                                                </div>}
                                                {prescription.rate && <div className="route drug-box">
                                                    {
                                                        `${prescription.rate} ml/hr`
                                                    }
                                                </div>}
                                                {prescription.volume && <div className="route drug-box">
                                                    {
                                                        `${prescription.volume} ml`
                                                    }
                                                </div>}
                                                {prescription.duration && <div className="route drug-box">
                                                    {
                                                        `${prescription.duration} hr`
                                                    }
                                                </div>}
                                            </div>
                                            <div className="drug-user">
                                                Dr. {
                                                    prescription.user
                                                }
                                            </div>
                                        </div>
                                    </td>
                                );
                            }
                            else if (header === CHART_HEADER_CONST.TYPE) {
                                return (
                                    <td className="drug-data-cell">
                                        <div className="drug-type">
                                            {prescription.type}
                                        </div>
                                    </td>
                                );
                            }
                            else if (header === CHART_HEADER_CONST.START_TIME) {
                                return (
                                    <td className="drug-data-cell">
                                        <div className="drug-start-time">
                                            {prescription.startTime || "-"}
                                        </div>
                                    </td>
                                );
                            }
                            else if (header === CHART_HEADER_CONST.ADDITIVES) {
                                return (
                                    <table>
                                        {prescription.additives && prescription.additives.map((additive, count) => {
                                            return (
                                                <tr className="drug-data-cell" key={additive.id}>
                                                    <td className="additive-width">{additive.name}</td>
                                                    <td>{additive.dosage}mg</td>
                                                </tr>
                                            );
                                        })}
                                    </table>
                                )
                            }
                            else if (header === CHART_HEADER_CONST.REMARKS) {
                                return (
                                    <td className="drug-data-cell">
                                        <div className="drug-remark">
                                            {prescription.remarks}
                                        </div>
                                    </td>
                                );
                            } else {
                                let headerTime = moment(header, timeFormat);
                                let administration =
                                    prescription.drugAdministrations
                                        .filter((administration) =>
                                            moment(administration.time, timeFormat).isSame(headerTime)
                                        )[0];
                                // console.log("administration", administration);

                                // if (administration)
                                let ifExist = ((administration != undefined));
                                let administrationId = (administration && administration.id) ||
                                    (`new-${prescription.id}-${header}`);

                                let isNew = administrationId && administrationId.toString().indexOf("new-") > -1;
                                return (
                                    <td className="drug-data-cell">
                                        <div className="administration">
                                            <input
                                                className="drug-checkbox"
                                                checked={ifExist}
                                                id={`${prescription.type}${row}${col}`}
                                                type="checkbox"
                                                aria-disabled={(!isNew || !props.isEditable || prescription.status === "STOP")}
                                                onChange={(event) => {
                                                    console.log("event input", event)
                                                    // handleChange(prescription.id, prescription.type, administrationId, header, event);
                                                }
                                                }
                                                onClick={(event) => handleTimeModal(event)}
                                            />
                                            {drugModal === `${prescription.type}${row}${col}` &&
                                                <div className="drug-modal-container">
                                                    <span>Drug Details</span>
                                                    <div className="time-picker-container">
                                                        <TimePicker
                                                            className="drug-time-picker"
                                                            onChange={(time) => setDrugTime(time)}
                                                            clearIcon={false}
                                                        />
                                                    </div>
                                                    <span className="time-error">{timeErr}</span>
                                                    <div className="modal-btn-container">
                                                        <div className="common-btn " onClick={handleModalCancel}>
                                                            Cancel
                                                        </div>
                                                        <div className={drugTime ? `common-btn modal-btn-active` : `common-btn modal-btn-inactive`} onClick={() => handleModalConfirm(prescription.id, prescription.type, administrationId, header)}>
                                                            Confirm
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            {administration && administration.userId && <div className="user">
                                                N{administration.userId}

                                                <div className="user-id-hover">
                                                    {/* <div className="id">
                                                        {administration.userId}
                                                    </div> */}
                                                    <div className="user-name">
                                                        {/* item.charAt(0).toUpperCase() + item.slice(1).toLowerCase()) */}
                                                        {`Administred by ${props.userRole.charAt(0).toUpperCase() + props.userRole.slice(1).toLowerCase()} ${administration.user}  (N${administration.userId}) at time ${administration.exactTime || '-'}`}
                                                    </div>
                                                </div>

                                            </div>
                                            }
                                        </div>
                                    </td>
                                );
                            }
                        })
                    }
                </tr >
            )
        });
        return html;
    }

    const getPrescriptionTypeTable = (type) => {
        let reqTable = props.data.filter((prescription) => prescription.type === type);
        let headerList = getDrugAdministrationHeader(type);
        let tableHtml = (
            <>
                {reqTable.length !== 0 && <thead key={0}>
                    {headerList && headerList.map((header, row) => {
                        return (
                            <th key={row}
                                className={row === 0 ?
                                    "heading cell sticky" : "heading cell"}
                            >
                                {header}
                            </th>)
                    })}
                </thead>}
                {reqTable.length === 0 && <thead className="empty-prescription-table">
                    <th>No Drugs Prescribed</th>
                </thead>}
                {getTablewiseHtml(reqTable, headerList)}
            </>
        )
        return tableHtml;
    }

    return (
        <>
            <div className="drug-administration-container">
                <div className="drug-table-container">
                    <span className="table-heading-common">Drugs</span>
                    <table className="drug-administration-table">
                        {getPrescriptionTypeTable(DRUG_ADMINISTRATION_TYPE.DRUG)}
                    </table>
                </div>
                <div className="infusion-table-container">
                    <span className="table-heading-common">Infusions</span>
                    <table className="infusion-administration-table">
                        {getPrescriptionTypeTable(DRUG_ADMINISTRATION_TYPE.INFUSION)}
                    </table>
                </div>
                <div className="stat-table-container">
                    <span className="table-heading-common">Stat Orders</span>
                    <table className="stat-administration-table">
                        {getPrescriptionTypeTable(DRUG_ADMINISTRATION_TYPE.STAT)}
                    </table>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = (state) => {

    return {
        userRole: state.userDataReducer.userRole,
    }
}

export default connect(mapStateToProps, null)(DrugAdminstration);